<template>
  <v-container fluid class="ma-4 pa-4">
    <v-row class="mx-4">
      <v-col lg="8">
        <v-row justify="start">
          <v-col cols="12" v-if="links.length">
            <v-row class="my-4">
              <h2 class="text-h4">{{ $t("links.intro") }} :</h2>
            </v-row>
            <v-card flat>
              <v-row class="my-4" v-for="(link, n) in links" :key="n">
                <links-cards-item :linksItem="link"></links-cards-item>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" v-else>
            <v-skeleton-loader
              v-if="loader"
              type="article, article, article, article, article"
            ></v-skeleton-loader>
            <div v-else>Pas de données</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LinksCardsItem from "../components/LinksCardsItem.vue";

export default {
  data() {
    return {
      links: [],
      loader: true,
    };
  },
  components: {
    LinksCardsItem,
  },
  beforeMount() {
    this.getLinks();
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
  methods: {
    async getLinks() {
      var request = { method: "GET", url: "/links" };
      try {
        var response = await this.axios(request);
        this.links = response.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>